import styled from 'styled-components';
import { BodyRegularL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const LoginCont = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 656px;
  justify-content: center;
`;

export const WelcomeMessage = styled(BodyRegularL)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `};
`;
